import type React from 'react';

import { type PropsWithChildren } from 'react';
import { useMemo, useState } from 'react';

import { type VacancyDetailsModel } from '@/views/vacancyDetails/model/VacancyDetails.model.ts';

import { CopyObjectContext, type CopyObjectContextProps } from './CopyObject.context';

export const CopyObjectContextProvider: React.FC<PropsWithChildren> = props => {
  const [vacancyDetailsCopy, setVacancyDetailsCopy] = useState<VacancyDetailsModel | null>(null);

  const context: CopyObjectContextProps = useMemo(() => {
    return {
      setVacancyDetailsCopy,
      vacancyDetailsCopy,
    };
  }, [vacancyDetailsCopy]);

  return <CopyObjectContext value={context}>{props.children}</CopyObjectContext>;
};
